import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

export interface ModalDepositUpdateProps {}

const ModalDepositUpdate = ({}: ModalDepositUpdateProps) => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.updateDeposit');
  const onClose = () => {
    closeSingleModal('updateDeposit');
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Atualizar depósito"
      height={'auto'}
      width={'70vw'}
    >
      <Form.Export.Deposit.Update />
    </Modal>
  );
};

export default ModalDepositUpdate;
